import React, { Fragment, useState } from 'react';
import { ReactComponent as Packages } from 'assets/img/my-screens/packages.svg';
import { EMPTY_STRING, POI_PACKAGE_STATUS } from 'commons/constants';
import VirtualList from 'reusable/VirtualList/VirtualList';
import Placeholder from 'reusable/Placeholder/Placeholder';
import NoTableData from 'atoms/NoTableData/NoTableData';
import TableHeader from 'atoms/TableHeader/TableHeader';
import './POITableData.scss';
import { Col, Input, Row } from 'reactstrap';

const POITableData = ({
  headerConfig,
  data,
  sortable,
  changingStatus,
  noDataMessage,
  initialMessage,
  onSort,
  rowComponent,
  label,
  changingStatus2,
}) => {
  const [search, setSearch] = useState(EMPTY_STRING);
  const { title, message, icon = Packages } = noDataMessage;
  const {
    title: initialTitle,
    message: _initialMessage,
    icon: initialIcon = Packages,
  } = initialMessage;

  if (changingStatus2 !== undefined && changingStatus2) {
    return <Placeholder type="table" height={300} />;
  }

  const handleSearch = (e) => {
    setSearch(e.target.value ?? EMPTY_STRING);
  };

  return (
    <div className="virtual-list-wrapper-new d-flex flex-column flex-grow-1">
      <Row>
        <Col xs="auto">
          {' '}
          <h4 className="poi_package_table_label ">{label}</h4>
        </Col>
        <Col xs={3}>
          <Input
            placeholder="Search Location"
            className="w-100"
            onChange={handleSearch}
            value={search}
            disabled={data.length === 0}
          />
        </Col>
      </Row>
      <TableHeader
        headerConfig={headerConfig}
        sortable={sortable}
        sortedBy={EMPTY_STRING}
        onSort={onSort}
        order={EMPTY_STRING}
        className="poi_package_table_header"
      />
      <div className="poi_package_table_wrapper">
        {changingStatus === POI_PACKAGE_STATUS.SUCCESS && data?.length > 0 && (
          <VirtualList itemData={{ items: (search ? data.filter((item) => item.placeName.toLowerCase().includes(search.toLowerCase())) : data) ?? [] }} itemHeight={20}>
            {rowComponent}
          </VirtualList>
        )}
        {changingStatus === POI_PACKAGE_STATUS.ONGOING && (
          <Placeholder type="table" height={200} />
        )}
        {(changingStatus === POI_PACKAGE_STATUS.FAILED ||
          (changingStatus === POI_PACKAGE_STATUS.SUCCESS &&
            data?.length === 0)) && (
          <NoTableData
            title={title}
            icon={icon}
            message={message}
            titleClassName="my-1 on_data_title"
            messageClassName="my-0"
            iconSize={20}
          />
        )}
        {changingStatus === POI_PACKAGE_STATUS.INITIAL && (
          <NoTableData
            title={initialTitle}
            icon={initialIcon}
            message={_initialMessage}
            titleClassName="my-1 on_data_title"
            messageClassName="my-0"
            iconSize={20}
          />
        )}
      </div>
    </div>
  );
};

export default POITableData;
